document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');

  document.querySelectorAll('[data-bfcm-nav]').forEach((navSection) => {
    const bar = navSection.querySelector('[data-nav-bar]');
    const spacer = navSection.querySelector('[data-nav-spacer]');
    const navItems = navSection.querySelectorAll('.bfcm-nav-item');

    if (!bar || !spacer || !navItems.length) return;

    const stickyEnabled = navSection.dataset.stickyOnScroll === 'true';

    let ticking = false;

    const getHeaderBottom = () => {
      if (!header) return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    };

    const getScrollOffset = () => {
      const headerBottom = getHeaderBottom();
      const navHeight = bar.classList.contains('is-sticky') ? bar.offsetHeight : 0;
      return headerBottom + navHeight;
    };

    const setActiveItem = (activeItem) => {
      navItems.forEach((item) => {
        const isActive = item === activeItem;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const scrollToTarget = (targetId) => {
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      history.replaceState(null, '', `#${targetId}`);

      const offset = getScrollOffset();
      const top = targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    };

    const updateStickyState = () => {
      if (!stickyEnabled) {
        bar.classList.remove('is-sticky');
        bar.style.removeProperty('--bfcm-nav-sticky-top');
        spacer.style.height = '0';
        return;
      }

      const headerBottom = getHeaderBottom();
      const sectionTop = navSection.getBoundingClientRect().top;
      const shouldStick = sectionTop <= headerBottom + 0.5;

      bar.classList.toggle('is-sticky', shouldStick);

      if (shouldStick) {
        bar.style.setProperty('--bfcm-nav-sticky-top', `${headerBottom}px`);
        spacer.style.height = `${bar.offsetHeight}px`;
      } else {
        bar.style.removeProperty('--bfcm-nav-sticky-top');
        spacer.style.height = '0';
      }
    };

    const syncStickyDuringHeaderTransition = () => {
      let frameCount = 0;

      const sync = () => {
        updateStickyState();
        frameCount += 1;

        if (frameCount < 15) {
          requestAnimationFrame(sync);
        }
      };

      requestAnimationFrame(sync);
    };

    const updateActiveByScroll = () => {
      const offset = getScrollOffset() + 8;
      const scrollPosition = window.scrollY + offset;
      let matchedItem = null;

      navItems.forEach((item) => {
        const targetId = item.getAttribute('data-target');
        if (!targetId) return;

        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        const moduleTop = targetElement.offsetTop;
        const moduleBottom = moduleTop + targetElement.offsetHeight;

        if (scrollPosition >= moduleTop && scrollPosition < moduleBottom) {
          matchedItem = item;
        }
      });

      if (matchedItem) {
        setActiveItem(matchedItem);
      }
    };

    const onScroll = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        updateStickyState();
        updateActiveByScroll();
        ticking = false;
      });
    };

    navItems.forEach((item) => {
      item.addEventListener('click', () => {
        const targetId = item.getAttribute('data-target');
        if (!targetId) return;

        setActiveItem(item);
        scrollToTarget(targetId);
      });
    });

    updateStickyState();
    updateActiveByScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateStickyState();
      updateActiveByScroll();
    });

    if (header) {
      const headerObserver = new MutationObserver(() => {
        syncStickyDuringHeaderTransition();
      });

      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class'],
      });

      header.addEventListener('transitionend', syncStickyDuringHeaderTransition);
    }

    const initialHash = window.location.hash.replace('#', '');
    if (initialHash) {
      const hashItem = Array.from(navItems).find(
        (item) => item.getAttribute('data-target') === initialHash
      );

      if (hashItem) {
        setActiveItem(hashItem);
        requestAnimationFrame(() => scrollToTarget(initialHash));
      }
    }
  });
});
